import { CircularProgress, Divider, Grid, Stack } from '@mui/material';

import { ContainerColumnLeft } from '@occc-app/design-system';
import { InfoField, LinkChip, CardLayout } from '@occc/ui-design-system';
import { routeCreator as surveyRouteCreator } from '@occc-app/routes/Survey/routeCreator';
import { SurveyAttribute } from '@occc-app/routes/Audience/types';

import {
  getRespondedStatus,
  getRespondedWithLabelToDisplay,
  getRespondedWithValueToDisplay,
} from './utils';

import { LocationGroupsInfoField } from '../LocationGroupsInfoField';
import { LocationsInfoField } from '../LocationsInfoField';

export type SurveysDetailsProps = {
  items: SurveyAttribute[];
};

export const SurveysDetails = ({ items }: SurveysDetailsProps) => {
  return (
    <ContainerColumnLeft>
      <CardLayout title='Surveys'>
        <Stack divider={<Divider />} spacing={0.5}>
          {items.map((item, i) => {
            const { survey, locations, locationGroups } = item;
            const respondedStatus = getRespondedStatus(item);
            const respondedWithLabel = getRespondedWithLabelToDisplay(item);

            return (
              <Grid container spacing={3} key={i}>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label='Member has'
                    value={respondedStatus === 'responded' ? 'Responded' : 'Not Responded'}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label='Survey Name'
                    value={
                      survey ? (
                        <LinkChip
                          href={surveyRouteCreator.details(survey.uuid)}
                          label={survey.name}
                        />
                      ) : (
                        <CircularProgress size={28} />
                      )
                    }
                  />
                </Grid>
                {respondedStatus === 'responded' && (
                  <Grid item xs={12} sm={12} md={6}>
                    <InfoField
                      label={respondedWithLabel}
                      value={getRespondedWithValueToDisplay(item)}
                    />
                  </Grid>
                )}
                {!!locations.length && (
                  <Grid item xs={12}>
                    <LocationsInfoField label='At This Location' locations={locations} />
                  </Grid>
                )}
                {!!locationGroups.length && (
                  <Grid item xs={12}>
                    <LocationGroupsInfoField
                      label='At This Location Group'
                      locationGroups={locationGroups}
                    />
                  </Grid>
                )}
              </Grid>
            );
          })}
        </Stack>
      </CardLayout>
    </ContainerColumnLeft>
  );
};
